<template>
  <div class="main-wrapper-container row-list-container">
    <header-title :main-title="mainTitle" :btn-info="btnInfo"/>
    <template-pagination
        @changePage="changePage"
        @changeValue="changeValueSearch"
        :is-loading="isLoadingItems"
        :active-page="pagination.page"
        :page-total="pagination.total"
    >
      <TableView
          :headers="headers"
          :items="servicesWithLabels"
          :is-active-search="false"
          @edit="item => editItem(item)"
          @delete="item => openModalDeleteService(item)"
      >
<!--        <template #edit-row="{ item }">-->
<!--          <div class="edit-content">-->
<!--            <tags-block-->
<!--                @changeTags="tags => editValue.tags = tags"-->
<!--                tags-title="Теги"-->
<!--                @closeTags="tag => removeTag(tag)"-->
<!--                :tags-out="editValue.tags"/>-->
<!--            <services-block-->
<!--                @changeService="value => editValue.relatedServices = value"-->
<!--                @closeService="removeRelatedServices"-->
<!--                :services-out="editValue.relatedServices"/>-->
<!--            <button-main-->
<!--                @click="saveItem(item)">-->
<!--              Сохранить-->
<!--            </button-main>-->
<!--          </div>-->
<!--        </template>-->
      </TableView>
    </template-pagination>
  </div>
</template>

<script>
import HeaderTitle from "@/components/entities/HeaderTitle.vue";
import TemplatePagination from "@/components/entities/pagination/TemplatePagination.vue";
import paginationMixin from "@/mixins/pagination.mixin";
import RowItem from "@/components/entities/items/RowItem.vue";
import modalAgreement from "@/mixins/modals/modalAgreement";
import TableView from "@/components/shared/table/TableView.vue";
import BigTitle from "@/components/shared/text/BigTitle.vue";
import InputMain from "@/components/shared/input/InputMain.vue";
import TagsBlock from "@/components/entities/CRUDBlock/TagsBlock.vue";
import ButtonMain from "@/components/shared/buttons/ButtonMain.vue";
import ServicesBlock from "@/components/entities/CRUDBlock/ServicesBlock.vue";
import {api} from "@/middleware/api";

export default {
  name: "ServicesPage",
  components: {
    ServicesBlock,
    ButtonMain,
    TagsBlock,  InputMain, BigTitle, TableView, RowItem, TemplatePagination, HeaderTitle
  },
  mixins: [paginationMixin, modalAgreement],
  data() {
    return {
      editValue: {
        tags: [],
        relatedServices: [],
      },
      services: [],
      isLoadingItems: false,
      headers: [
        {text: 'Название', value: 'name'},
        {text: 'Дата изменения', value: 'updatedAt'},
        {text: 'Теги', value: 'tagsLabel', class: 'td-tags'},
      ],
      mainTitle: 'Услуги',
      btnInfo: {
        text: 'Добавить Услугу',
        action: () => this.openCreateNews()
      },
      timer: null
    }
  },
  created() {
    this.fetchInfo();
  },
  computed: {
    servicesWithLabels() {
      return this.services.map(item => ({
        ...item,
        tagsLabel: item.tags.map(tag => `#${tag.translations[0].content}`).join(', '),
        updatedAt: this.formatDate(item.updatedAt),
        name: item.translations[0].title,
      }))
    }
  },
  methods: {
    async fetchInfo() {
      this.IS_GLOBAL_LOADING(true)
      const { data } = await api.dashboard.adminCasesControllerFindAll({
        ...this.search !== ''
            ? { title: this.search }
            : {},
        limit: this.pagination.limit,
        offset: this.activeOffset
      })
      this.pagination.offset = data.offset;
      this.pagination.total = Math.ceil(data.total / this.pagination.limit)
      this.services = data.items.map(item => ({
        ...item,
        publishedAt: this.formatDate(item.publishedAt)
      }));
      this.IS_GLOBAL_LOADING(false)
    },
    editItem(item) {
      this.$router.push({
        name: 'services-edit',
        params: {
          id: item.id
        }
      })
    },

    removeTag(item) {
      this.editValue.tags = this.editValue.tags.filter(e => e !== item)
    },
    openCreateNews() {
      this.$router.push({
        name: 'services-create'
      })
    },
    async removeService(item) {
      await api.dashboard.adminCasesControllerRemove(item.id)
      this.services = this.services.filter(e => e.id !== item.id)
    }
  }
}
</script>

<style scoped>

</style>